import type {Cart} from '../models/Cart';
import {CartRepository} from '../repositories/CartRepository';
import ApiClient from '../../API/api';

const ADD_PRODUCT_ENDPOINT = 'cart/product';

export class CartService {
  static async changeEquivalenceCharges(product): Promise<void> {
    return CartRepository.setEquivalenceCharge(product.id, !product.equivalenceCharge);
  }

  static get(): Promise<Cart> {
    return CartRepository.get();
  }

  static removeProduct(product): Promise<void> {
    return CartRepository.removeProduct(product.id)
  }

  static validate(): Promise<boolean> {
    return CartRepository.validate();
  }

  static addProduct = (productId, price, quantity, bcDiscounts, giftProductDeal): Promise<Cart> => {
    return ApiClient.performRequest(
      ADD_PRODUCT_ENDPOINT,
      {
        method: 'POST',
        body: {
          productId: productId,
          quantity: quantity,
          sellingPrice: price.sellingPrice,
          basePrice: price.basePrice,
          packParentId: null,
          bcDiscounts: bcDiscounts
        }
      }
    ).then((response) => {
      if (response && giftProductDeal) {
        return ApiClient.performRequest(
          ADD_PRODUCT_ENDPOINT,
          {
            method: 'POST',
            body: {
              productId: giftProductDeal.THR_Charge_Item_No_[0].id,
              quantity: Math.floor(quantity / giftProductDeal.RLD_Cant__Min__Promocion) * giftProductDeal.THR_Quantity,
              sellingPrice: giftProductDeal.THR_Sales_Price,
              basePrice: giftProductDeal.THR_Sales_Price,
              packParentId: productId,
              bcDiscounts: {
                descBc1: 0,
                descBc2: 0,
                descBc3: 0,
                descBc4: 0,
                descBc5: 0,
                descBc6: 0,
                descBc7: 0,
                descBc8: 0,
                descBc9: 0,
                descBc10: giftProductDeal.descBc10
              }
            }
          }
        );
      }
      return response;
    });
  };
}